import { Delete, Download, Edit, TextStyleSmall } from '@wix/wix-ui-icons-common/on-stage';
import { BoxSelection, BoxSelectionBoxSize, Checkbox, IconButton } from '@wix/wix-ui-tpa/cssVars';
import classNames from 'classnames';
import React from 'react';
import { DATA_HOOKS } from '../../../constants';
import { useTranslation } from '../../../sdk/components';
import { SignatureMode } from '../signature-types';
import commonStyles from '../styles/common.module.scss';
import { classes } from './signature-header-wut.st.css';
export const SignatureHeaderWUT = ({ signatureMode, onModeChange, onClear, clearable, uploadEnabled, inputId, ariaLabelledBy, target })=>{
    const { t } = useTranslation();
    const handleModeChange = ({ id })=>{
        onModeChange(id);
    };
    const modeOptions = [
        /*#__PURE__*/ React.createElement(BoxSelectionItem, {
            className: classes.option,
            key: SignatureMode.DRAW,
            id: SignatureMode.DRAW,
            checked: signatureMode === SignatureMode.DRAW,
            "aria-label": t('field.signature.mode.draw.label'),
            size: BoxSelectionBoxSize.small
        }, /*#__PURE__*/ React.createElement(Edit, {
            className: classes.icon,
            size: "24",
            "aria-hidden": true
        })),
        /*#__PURE__*/ React.createElement(BoxSelectionItem, {
            className: classes.option,
            key: SignatureMode.TYPE,
            id: SignatureMode.TYPE,
            checked: signatureMode === SignatureMode.TYPE,
            "aria-label": t('field.signature.mode.type.label')
        }, /*#__PURE__*/ React.createElement(TextStyleSmall, {
            className: classes.icon,
            size: "24",
            "aria-hidden": true
        })),
        uploadEnabled && /*#__PURE__*/ React.createElement(BoxSelectionItem, {
            className: classes.option,
            key: SignatureMode.UPLOAD,
            id: SignatureMode.UPLOAD,
            checked: signatureMode === SignatureMode.UPLOAD,
            "aria-label": t('field.signature.mode.upload.label')
        }, /*#__PURE__*/ React.createElement(Download, {
            className: classes.icon,
            size: "24",
            "aria-hidden": true
        }))
    ].filter(Boolean);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames(classes.container)
    }, /*#__PURE__*/ React.createElement("div", {
        className: commonStyles.visuallyHidden,
        "aria-live": "polite"
    }, signatureMode === SignatureMode.DRAW && t('field.signature.mode.draw.description'), signatureMode === SignatureMode.TYPE && t('field.signature.mode.type.description'), signatureMode === SignatureMode.UPLOAD && t('field.signature.mode.upload.description')), /*#__PURE__*/ React.createElement(BoxSelection, {
        className: classes.boxSelection,
        size: BoxSelectionBoxSize.small,
        name: "signature-mode",
        onChange: handleModeChange,
        "aria-labelledby": ariaLabelledBy,
        "aria-controls": inputId,
        "data-hook": DATA_HOOKS.SIGNATURE_FIELD_MODE_SELECT
    }, modeOptions), clearable && /*#__PURE__*/ React.createElement(IconButton, {
        onClick: onClear,
        "data-hook": `clear-${target}`,
        "aria-label": t('field.signature.clear-button.label'),
        "aria-controls": inputId,
        role: "button",
        icon: /*#__PURE__*/ React.createElement(Delete, {
            className: classes.clearIcon,
            "aria-hidden": "true"
        })
    }));
};
export const BoxSelectionItem = (props)=>{
    const { children, ...rest } = props;
    return /*#__PURE__*/ React.createElement(BoxSelection.Option, rest, children);
};
// fix to include Checkbox styles in bundle https://wix.slack.com/archives/CH32ANHNF/p1715770531405829?thread_ts=1715607100.247089&cid=CH32ANHNF
BoxSelectionItem.includeCheckboxInBundle = Checkbox;

//# sourceMappingURL=signature-header-wut.js.map